import axios from 'axios'

const UserService = {
  async getList (params = {}) {
    return axios.get('admin/users', { params })
  },

  async show (id) {
    return axios.get(`admin/users/${id}`)
  },

  async store (data) {
    return axios.post('admin/users', data)
  },

  async update (id, data) {
    return axios.put(`admin/users/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/users/${id}`)
  }
}

export default UserService
